import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import { Message, Icon, Button, List } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './ServiceShareCancelUser.css';
const cx = classNames.bind(styles);

class ServiceShareCancelUser extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { onProgress, shareInfo, cancelShareUser, handleOnToggleCancelModal } = this.props;
    const { userNo, userName, userEmail, regEpoch } = shareInfo;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'common-content')}
        closeIcon
        onToggleModal={handleOnToggleCancelModal}
        visible
        header={
          <div>
            {defineMessages(formatMessage({ id: 'ServiceShareCancelUser_1', defaultMessage: '공유 사용자 취소' }))}
          </div>
        }
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleCancelModal}>
              {defineMessages(formatMessage({ id: 'ServiceShareCancelUser_2', defaultMessage: '닫 기' }))}
            </Btn>
            <Btn className={cx('gray-button')} loading={onProgress} disabled={onProgress} onClick={cancelShareUser}>
              {defineMessages(formatMessage({ id: 'ServiceShareCancelUser_3', defaultMessage: '공유 취소' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={onProgress}
          size="small"
          content={defineMessages(formatMessage({ id: 'ServiceShareCancelUser_4', defaultMessage: '삭제중...' }))}
        />
        <div className={cx('message-header')}>
          {ReactHtmlParser(
            defineMessages(
              formatMessage({
                id: 'ServiceShareCancelUser_5',
                defaultMessage:
                  '공유한 사용자를 취소합니다.<br/>해당 사용자는 서비스에 접근할 수 없게 됩니다.<br/>정말로 다음 공유 사용자를 취소합니까?'
              })
            )
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            {/* <div className={cx('template-detail-name')}>세부정보</div> */}
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareCancelUser_6', defaultMessage: '사용자No' }))}
                </div>
                {userNo}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareCancelUser_7', defaultMessage: '사용자명' }))}
                </div>
                {userName}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareCancelUser_8', defaultMessage: '이메일' }))}
                </div>
                {userEmail}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareCancelUser_9', defaultMessage: '공유추가' }))}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

ServiceShareCancelUser.propTypes = {
  //
};
ServiceShareCancelUser.defaultProps = {
  //
};

export default injectIntl(ServiceShareCancelUser);



// WEBPACK FOOTER //
// ./src/script/components/share/ServiceShareCancelUser.js